Vue.component('admin-user-subscription', {
    template: templates.adminUserSubscriptions,
    data() {
        return {
            model: {
                edit: false,
                users_subscription: [],
                updateUser:  {
                    id: null,
                    status: 'pending',
                },
                status: [
                    { value: 'pending', name: 'Pending' },
                    { value: 'approved', name: 'Approve' },
                    { value: 'decline', name: 'Decline' },
                ],
                searchTerm: '',
                isLoading: false,
                hasResult: false
            }
        }
    },
    computed: {
        filteredMembers() {
            const c = this;
            const searchTermLower = c.model.searchTerm.toLowerCase();

            console.log(searchTermLower);
        
            return c.model.users_subscription.filter(member => {
                const hasDisplayName = member.twitchDisplayName && member.twitchDisplayName.length > 0;
                
                return (
                    (member.twitchId && member.twitchId.includes(searchTermLower)) ||
                    (hasDisplayName && member.twitchDisplayName[0].twitchDisplayName && 
                     member.twitchDisplayName[0].twitchDisplayName.toLowerCase().includes(searchTermLower))
                );
            });
        },
    },
    mounted() {
        const c = this;
        c.get();
        c.$root.$on('updateUserSubscription', data => {
            c.get();
            setTimeout(function(){
                c.reset(); 
            }, 1000)
        })
    },
    methods: {
        get() {
            const c = this;
            let data = {};
            subscriptionService.getUserSubscriptions().then(function(response) {
                console.log(response.data)
                for (let d of response.data) {
                    data[`${d.id}`] = d;
                }
                c.model.hasResult = true;
                c.model.users_subscription = Object.values(data);
                c.model.isLoading = true;

                console.log(data)
               
            })
            .catch(function(error) {
                console.log(error);
                c.model.isLoading = true;
                c.model.hasResult = false;
          
            });
        },
        add() {
            const c = this;
            c.model.edit = true;
        },
        reset() {
            const c = this;
            c.model.edit = false;
            c.model.updateUser  = {
                id: null,
                status: 'pending',
            }
        },
        edit(userId) {
            const c = this;
            const data = c.model.users_subscription.find(user => user.id === userId);
            if (data) {
                c.model.edit = true;
                c.model.updateUser  = {
                    id: data.id,
                    status: data.status,
                }
            }
        },
        save() {
            const c = this;
            let data = {
                message: 'Save Changes',
                userData: c.model.updateUser,
                cancel: false,
                twitchId: utils.cookies.get('user_id')
            }
            $('.modal').addClass('is-above').addClass('is-visible');
            c.$root.$emit('confirmUpdateSubscription', data);
        },
        cancel(){
            const c = this;

            let data = {
                message: 'Are you sure you want to cancel this subscription?',
                userData: c.model.updateUser,
                cancel: true,
                twitchId: utils.cookies.get('user_id')
            }
            console.log(data)
            $('.modal').addClass('is-above').addClass('is-visible');
            c.$root.$emit('confirmUpdateSubscription', data);
            
            
        }
    }
});
